export default __webpack_public_path__ + "assets/favicon.060e1b4311cd634920df88398a51d07e.svg";